<template>
	<div class="update-plan" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                   <div class="card-body">
                          <h4 class="mb-3">ユプラン変更</h4>
                          <div>
                              <transition name="slide-fade">
                              <div class="alert alert-success" v-if="info" >{{ info }}</div>
                            </transition>

                            <div class="form-group site-selection-area">
                              <label for="site">変更対象サイト<span class="badge badge-required">必須</span></label>
                              <div class="input-group" id="group1">
                                <select  class="" name="sSite"  id="select1" @change="onSiteSelect">
                                  <option v-for="site in allSites" :key="site.id" :value="site.id" :selected="selectedSite == site.id"> {{ site.site_name_jp }}</option>
                                </select>
                                <div class="selected-option"><span class="opt-val">{{ selectedDomain }}</span></div>
                              </div>
                            </div>

                           
                            <div class="form-group ">
                              <label for="site">現在のプラン</label>
                              <span>{{ currentPlanTitle }}</span>
                            </div>
                            <div>

                              <div class="plan-slider">
                              <label class="switch btn-mode-switch">
                              <input type="checkbox" name="switcher" id="switcher" @change="onPlanChange" value="1">
                              <label for="switcher" data-on="Annual" data-off="Monthly" class="btn-mode-switch-inner"></label>
                          </label>

                        </div>
                          <div id="planDetail" class="plan-detail">
                            <ul>
                             
                              <li v-for="(plan, key)  in allPlans"  >
                                <div class="title"><span class="plan-title">{{ plan.title }}</span></div>
                                <div class="desc">{{ plan.plan_desc }}</div>

                                
                                <div v-html="getPrice(plan)" :class="isAnnual ? 'price annual-txt' : 'price'"></div>

                                <div class="btn-wrap" v-if="plan.title === currentPlanTitle"><span>現在のプラン</span></div>
                                <div class="btn-wrap" v-else>
                                  <button
                                    @click="upgradePlan(plan)"
                                    type="button" class="btn btn-white">
                                    {{ plan.title == 'Enterprise' ? 'お問い合わせ' : 'アップグレード' }}
                                  </button>
                                </div>

                                <div class="send-limit"> {{ getMaxSendLimit(plan) }} </div>
                                <div class="subscriber-limit"> {{ getMaxSubscriberLimit(plan) }} </div>                                
                                <div class="other-support" v-html="getOthers(plan)"></div>
                              </li>
                             
                            </ul>
                          </div>


                  </div>
					          </div>
                </div>
            </div>
			
		</div>
	</div>

  <modal :show.sync="modal" class="plan-confirm-modal">
              <h4 slot="header" class="modal-title">契約プラン確認</h4>
              <div class="form-group target-site">
                <label class="title">変更対象サイト</label>
              <span>サイト名　　　{{ selectedSiteName }}</span>
              <span>ドメイン　　　{{ selectedDomain }}</span>
              </div>
              <div id="ModalplanDetail" class="plan-detail">
                <ul>
                  <li class="current-plan">
                    <label class="title">現在のプラン</label>
                    <div class="plan-name"> {{ currentPlan.title }} </div>
                    <div class="send-limit"> {{ getMaxSendLimit(currentPlan) }} </div>
                        <div class="subscriber-limit"> {{ getMaxSubscriberLimit(currentPlan) }} </div>                                
                        <div class="other-support" v-html="getOthers(currentPlan)"></div>
                  </li>


                  <li class="new-plan">
                    <label class="title">変更後のプラン</label>
                    <div class="plan-name"> {{ newPlan.title }} </div>
                    <div class="send-limit"> {{ getMaxSendLimit(newPlan) }} </div>
                        <div class="subscriber-limit"> {{ getMaxSubscriberLimit(newPlan) }} </div>                                
                        <div class="other-support" v-html="getOthers(newPlan)"></div>
                  </li>
                </ul>
              </div>
              <div class="form-group text-center"><base-button @click="openPayment(newPlan)" type="primary">支払い方法入力</base-button></div>
             
            </modal>


            <modal :show.sync="paymentModal" class="payment-modal">
              <h4 slot="header" class="modal-title">支払い方法の選択</h4>
              
              <ul class="radio-container">
                <li>
                  <base-radio class="mb-3" name="credit"  v-model="radio"  :inline="true" >
                      クレジェットカード
                  </base-radio>
                </li>                             
                <li>
                  <base-radio class="mb-3" name="invoice" v-model="radio" :inline="true" >
                      請求書払い
                  </base-radio>
                </li>
              </ul>

                        
              <input type="hidden" name="plan" v-model="planTitle" id="plan">
              <div v-show="isCreditCard">
              <div class="form-group">
                  <label for="">カード保有者名<span class="badge badge-required">必須</span></label>
                  <input type="text" name="card_holder_name" v-model="cardHolderName" id="card-holder-name" class="form-control" value="" placeholder="">
              </div>
              <div class="form-group">
                <!-- Card element -->
                <!--
                  <label for="">Card details</label>
                  <div id="card-element"></div>
                -->

                  <label>クレジェットカード番号<span class="badge badge-required">必須</span></label>
                  <div id="card-number"></div>
                  </div>
                  <div class="form-group">

                    <div class="form-row">
                      <div class=" col-md-6">
                        <label>有効期限<span class="badge badge-required">必須</span></label>
                        <div id="card-expiry"></div>
                      </div>
                      <div class="col-md-6">
                        <label>CVC<span class="badge badge-required">必須</span></label>
                        <div id="card-cvc"></div>
                      </div>
                    </div>
                  </div>
                  
                  <div id="card-error"></div>

                           <!-- Mount the Payment Element here -->
                           <!-- <div id="payment-element"></div>-->
                        
                      </div>
              <div class="form-group text-center"><base-button  id="card-button" type="primary" @click="startPayment(newPlan)">{{ isPaymentChange ? '支払い': '更新'  }}</base-button></div>
            </modal>
  </div>
</template>
<script>
 
 import ConfirmDialogue from './ConfirmDialogue.vue'
 import { StripeCheckout } from '@vue-stripe/vue-stripe';
 import axios from 'axios'
export default {
  components: {
    ConfirmDialogue,
    StripeCheckout
  },
  props: ['planList', 'sitePlan', 'selectedSite','stripeData'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
      allPlans:{},
      stripeInfo:{},
      selectedSite:0,
      radio:"credit",
      isCreditCard: true,
      plan:{},
      category: "",
      modal:false,
      paymentModal:false,
      allSites: {},
      errors: {},
			siteId:0,
      loading: false,
      info:null,
      //selectedSite:'',
      currentPlanTitle: "",
      currentPlan: {},
      newPlan:{},
      isMonthly: false,
      selectedDomain: "",
      selectedSiteName: "",
      isAnnual: false,
      cardElement:null,
      paymentElement:null,
      cardHolderName:"",
      planTitle:"",
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      complete: false,
      state: {
        cardNumber: false,
        cardExpiry: false,
        cardCv: false
      }
		}
	},

  beforeDestroy () {
    this.cardNumber.destroy();
    this.cardExpiry.destroy();
    this.cardCvc.destroy();
  },

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
    this.getSiteList();
    this.allPlans = JSON.parse(this.planList);
    this.plan = JSON.parse(this.sitePlan);
    this.stripeInfo = JSON.parse(this.stripeData);
    this.setcurrentPlanTitle();
    
    
    const that = this;
    $(document).ready(function() {
    $("#switcher").on("change", function () {
      that.colorModePreview(this);
    })
    });

    //this.plan[0] ? this.selectedSite = this.plan[0].site_id : "";
    
    //this.show();
    /*
      const url = '/subscription/status';
      axios.get(url)
          .then(this.setStatus);
    }*/
	},

  computed:{
  isPaymentChange() {
      if(this.radio == "credit") {
        this.isCreditCard = true;
        return true;
      }
      this.isCreditCard = false;
      return false;
    },

    isSubscribed() {
      return (this.status === 'subscribed' || this.status === 'cancelled');
    },
    isCancelled() {
      return (this.status === 'cancelled');
    }
},

	methods: {
    //https://blog.capilano-fw.com/?p=3893
    setStatus(response) {
      this.status = response.data.status;
      //this.details = response.data.details;
    },
    async subscribe(planId) {
      const paymentMethod = await this.getPaymentMethod();
      const url = '/subscription/subscribe';
     
        console.log(paymentMethod)
        const params = {
          payment_method: paymentMethod,
          site_id: this.selectedSite,
          site_domain: this.selectedDomain,
          plan_id: planId,
        };
        axios.post(url, params)
          .then(response => {
            console.log(response)
            location.reload();
        }); 
    },
    cancel() {
      const url = '/subscription/cancel';
      axios.post(url)
        .then(this.setStatus);
    },
    resume() {
      const url = '/subscription/resume';
      axios.post(url)
          .then(this.setStatus);
    },
    changePlan() {
      const url = '/subscription/change_plan';
      const params = { plan: this.plan };
      axios.post(url, params)
          .then(this.setStatus);
    },
    async updateCard(e) {
      const paymentMethod = await this.getPaymentMethod(e.target);
      const url = '/subscription/update_card';
      const params = { payment_method: paymentMethod };
      axios.post(url, params)
          .then(response => {
            console.log(response)
            location.reload();
      });
    },

    setcurrentPlanTitle() {
      this.currentPlanTitle = "";
      for(let i=0; i< this.plan.length; i++) {
          if(this.plan[i].site_id == this.selectedSite) {
            this.currentPlanTitle = this.allPlans[this.plan[i].plan_id].title;
            this.currentPlan = this.allPlans[this.plan[i].plan_id];
          }
        }
    },
    setSelectedDomain() {
      this.selectedDomain = "";
        for(let i=0; i< this.allSites.length; i++) {
          if(this.allSites[i].id == this.selectedSite) {
            this.selectedDomain = this.allSites[i].site_domain;
            return;
          }
        }
    },
    getSiteList() {
			axios.get('/sites')
				.then(response => {
          this.allSites = response.data;
          this.setSelectedDomain();
          this.setSelectedSite();
				});
		},

    colorModePreview(ele) {
        if($(ele).prop("checked") == true){
            $('#planDetail').addClass('show-monthly');
            $('#planDetail').removeClass('show-annualy');
        }
        else if($(ele).prop("checked") == false){
          $('#planDetail').addClass('show-annualy');
          $('#planDetail').removeClass('show-monthly');
        }
    },

    onSiteSelect(event) {
      const target = event.target;
      const val = target.value;
      //this.selectedSite.push(val);
      this.selectedSite = val;
      this.setSelectedSite();
    },

    setSelectedSite() {
      for(let i=0; i< this.allSites.length; i++) {
          if(this.allSites[i].id == this.selectedSite) {
            this.selectedDomain = this.allSites[i].site_domain;
            this.selectedSiteName = this.allSites[i].site_name_jp;
            this.setcurrentPlanTitle();
            console.log("selectedSiteName:",this.selectedSiteName)
            return;
          }
      }
    },
    onPlanChange(event) {
      this.isAnnual = event.target.checked;
      /*monthlyの場合false, Annualの場合true*/
      //this.selectedSite.push(val);
    },
    getOthers(plan) {
      if(!plan.title) return;
      return (plan.others).replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    getPrice(plan) {
      if(!plan.title) return;
      const pName = (plan.title).toLowerCase();
      if(pName === "free") {
        return "<span class='amnt'>Free</span>";
      } else if(pName === "enterprise") {
        return "<span><img alt='お問い合わせ' src='/img/icons/contact_icon.svg'></span>";
      } else {
        let price = 0;
        let discout = 0;
        if(this.isAnnual) {
          price = plan.plan_price_yearly
          discout = (plan.plan_price_monthly - plan.plan_price_yearly) * 12;
        } else {
          price = plan.plan_price_monthly
        }
        const formattedPrice =  new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 3 }).format(price);
        const formattedDiscount =  new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 3 }).format(discout);
        let priceHTML = "<span class='amnt'>"+formattedPrice+"</span><span class='amnt-post-fix'> / 月</span>";
        
        if(this.isAnnual) {
          priceHTML = priceHTML + "<br><span class='discount-txt' >年間プランで"+formattedDiscount+"円 割引</span>";
        }
        return priceHTML;
      }
    },

    getMaxSendLimit(plan) {
      let limit = 0;
      let html = "";
      if(!plan.title) return;
      const pName = (plan.title).toLowerCase();
      if(this.isAnnual) {
        limit = plan.delivery_limit_yearly
        html = new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 3 }).format(limit);
        html = "配信数　　　" + html + " 通 / 年";
      } else {
        limit = plan.delivery_limit_monthly;
        html = new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 3 }).format(limit);
        html = "配信数　　　" + html + " 通 / 月";
      }

      if(pName === "enterprise") {
        html = "配信数のカスタマイズ";
      }
        
      return html;
    },
    getMaxSubscriberLimit(plan) {
      if(!plan.title) return;
      const pName = (plan.title).toLowerCase();
      if(pName === "enterprise") {
        return "許諾数のカスタマイズ";
      } else {
      const html = new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 3 }).format(plan.subscriber_limit);
      return "許諾数　　　" + html + "　  件";
      }
    },
    upgradePlan(plan) {
      this.modal = true;
      this.newPlan = plan;
      this.planTitle = plan.title;
    },
    openPayment(plan) {
      console.log(this.stripeInfo);
      this.modal = false;
      this.paymentModal = true;

      const elements = stripe.elements();
      elements.update({locale: 'ja'});

      const style = {
      base: {
        color: 'black',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };
    this.cardNumber = elements.create('cardNumber', { style });
    this.cardNumber.mount('#card-number');
    this.cardNumber.addEventListener('change', event => {
        this.state.cardNumber = event.complete;
        if (event.complete) {
          this.cardExpiry.focus();
        }
        //this.onInputComplete(this.completed());
      });
    this.cardExpiry = elements.create('cardExpiry', { style });
    this.cardExpiry.mount('#card-expiry');
    this.cardExpiry.addEventListener('change', event => {
        this.state.cardExpiry = event.complete;
        if (event.complete) {
          this.cardCvc.focus();
        }
        //this.onInputComplete(this.completed());
      });


    this.cardCvc = elements.create('cardCvc', { style });
    this.cardCvc.mount('#card-cvc');
    this.cardCvc.addEventListener('change', event => {
        this.state.cardCvc = event.complete;
       // this.onInputComplete(this.completed());
       
      });

    },

    async startPayment(plan) {
      console.log(plan);
      this.subscribe(plan.id);

      /*
      var tok = this.getToken(this.cardNumber);
    
    tok.then(response => {
				  console.log(response)
				  //this.id = response.data.result.id;
          this.subscribe(plan.id);
			  }).catch(error => {
				console.log(error)
				if (error.response.status === 422) {
					
					this.error = true;
           			this.loading = false;
        		}
      });
      */
    },
        
    async getPaymentMethod() {
      const clientSecret = this.stripeInfo.intent.client_secret;
      console.log(this.stripeInfo.intent)
      const { setupIntent, error } = await stripe.confirmCardSetup(
          clientSecret, {
              payment_method: {
                  card: this.cardNumber,
                  billing_details: { name: this.cardHolderName }
              }
          }
      );
      if (error) {
          console.log(error);
      } else {
        console.log("setupIntent:", setupIntent)
          return setupIntent.payment_method;
      }
    },
    doUpdateSubscription (token) {
      console.log(this.newPlan);
      axios.post('/change_plan', {
        //_method:"PUT",
      	token:token,
      	plan:this.planTitle,
      	name:this.cardHolderName
      	
      }).then(response => {
        //this.loading = false;
        this.$toast(response.data.info, {
          toastClassName: "toaster"
        })
        //this.info = response.data.info;
        this.resetFields();
        this.$toast("Payment is done", {
          timeout: false,
          toastClassName: "toaster"
        });
        
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
           this.loading = false;
           //this.info = error.response.data.info
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、保存できませんでした。ページをリロードしてください")
        }
      });
    }

  ,
  openPaymentNew(plan) {
      
      this.modal = false;
      this.paymentModal = true;

      const elements = stripe.elements({
        fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=Source+Code+Pro' }]
      });

      elements.update({locale: 'ja'});

      const elementStyles = {
        base: {
          color: '#32325D',
          fontWeight: 500,
          fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
          fontSize: '1.2em',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#CFD7DF'
          },
          ':-webkit-autofill': {
            color: '#e39f48'
          }
        },
        invalid: {
          color: '#E25950',
          '::placeholder': {
            color: '#FFCCA5'
          }
        }
      };
      const elementClasses = {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid'
      };
      
      this.cardNumber = elements.create('cardNumber', {
        style: elementStyles,
        classes: elementClasses
      });
      this.cardNumber.mount('#card-number');
      this.cardNumber.addEventListener('change', event => {
        this.state.cardNumber = event.complete;
        if (event.complete) {
          this.cardExpiry.focus();
        }
        //this.onInputComplete(this.completed());
      });

      this.cardExpiry = elements.create('cardExpiry', {
        style: elementStyles,
        classes: elementClasses
      });
      this.cardExpiry.mount('#card-expiry');
      this.cardExpiry.addEventListener('change', event => {
        this.state.cardExpiry = event.complete;
        if (event.complete) {
          this.cardCvc.focus();
        }
        //this.onInputComplete(this.completed());
      });

      this.cardCvc = elements.create('cardCvc', {
        style: elementStyles,
        classes: elementClasses
      });
      this.cardCvc.mount('#card-cvc');
      this.cardCvc.addEventListener('change', event => {
        this.state.cardCvc = event.complete;
       // this.onInputComplete(this.completed());
      });
    },
    completed() {
      return this.state.cardNumber && this.state.cardExpiry && this.state.cardCvc;
    },
    async getToken() {
      return await stripe.createToken(this.cardNumber);
    }
  }
}
</script>

<style scoped>

.plan-slider {
  text-align: center;
}

label {
    font-size: 14px;
    color: #424242;
    font-weight: 500;
}

.btn-mode-switch{
    display: inline-block;
    margin: 0px;
    position: relative;
}

.btn-mode-switch > label.btn-mode-switch-inner{
    margin: 0px;
    width: 262px;
    height: 42px;
    background: #E0E0E0;
    border-radius: 26px;
    overflow: hidden;
    position: relative;
    transition: all 0.3s ease;
    /*box-shadow: 0px 0px 8px 0px rgba(17, 17, 17, 0.34) inset;*/
    display: block;
}

.btn-mode-switch > label.btn-mode-switch-inner:before{
    content: attr(data-on);
    width:50%;
    position: absolute;
    font-size: 14px;
    font-weight: 500;
    top: 1px;
    right: 1px;
    display:block;
    line-height:40px;
    text-align: center;

}

.btn-mode-switch > label.btn-mode-switch-inner:after{
    content: attr(data-off);
    width: 50%;
    height: calc(100% - 2px);
    background: #fff;
    border-radius: 26px;
    position: absolute;
    left: 1px;
    top: 1px;
    text-align: center;
    transition: all 0.3s ease;
    padding: 5px 0px;
    display:block;
   line-height:30px;
    color: #5e72e4;
    border:1px solid #5e72e4
}

.btn-mode-switch input[type="checkbox"]{
    cursor: pointer;
    width: 50%;
    height: calc(100% - 2px);
    opacity: 0;
    position: absolute;
    top: 0;
    z-index: 1;
    margin: 0px;
}

.btn-mode-switch input[type="checkbox"]:checked + label.btn-mode-switch-inner:after{
    content: attr(data-on);
    left: calc(50% - 1px);
    color: #5e72e4;
    border:1px solid #5e72e4
   
}

.btn-mode-switch input[type="checkbox"]:checked + label.btn-mode-switch-inner:before{
    content: attr(data-off);
    right: auto;
    left: 20px;
    width: 50%;
    height: calc(100% - 2px);
}

.plan-detail {
  text-align: center;
}
.plan-detail ul {
  text-align:left;
}
.plan-detail li {
  display: inline-grid;
  width: 250px;
  border:1px solid #EAEAEA;
  margin: 5px;
  font-size: 14px;
}
.plan-confirm-modal .plan-detail li,
.payment-modal .plan-detail li{
  width: 300px;
  border:none;
}
.plan-detail li div
{
  display:block;
  width:100%;
  padding: 10px 12px;
  overflow:hidden;
  
  
}

.plan-detail li div.other-support {
  min-height: 270px;
  
}
.payment-modal,
.plan-confirm-modal {
  color: #32325d;
}

.title {
  border-bottom: 1px solid #EAEAEA;
  padding: 10px 0;
  text-align:center;
}

.plan-confirm-modal label.title,
.payment-modal label.title{
font-size: .9rem;
color: #212121;
font-weight: 700;
display: block;
border:none;
text-align:left;
}

.desc {
  height: 140px;
}


.btn-wrap {
  padding-top: 20px;
  padding-bottom: 20px;
}
.btn-wrap span {
  display:block;
  padding: 10px;
  border: 1px solid #757575;
  border-radius: 4px;
  background: #EAECF0;
  width: 90%;
  margin:auto;
  text-align:center;
}

.plan-detail li div.send-limit,  .plan-detail li div.subscriber-limit, .plan-detail li div.other-support {
    padding-top: 0;
    padding-bottom:0;
    line-height: 32px;
   }
   .btn-white:hover,
   .btn-white {
    box-shadow: none;
    color: #3F51B5;
    border: 1px solid #3F51B5;
    border-radius: 4px;
    width: 90%;
    margin:auto;
    display:block;
    text-align:center;
   }
   
   .plan-confirm-modal .target-site span,
   label.title .target-site span
   {
    display: block;
    padding: 4px;
   }

</style>